import { render, staticRenderFns } from "./dormStaff.vue?vue&type=template&id=1d1fd302&scoped=true"
import script from "./dormStaff.vue?vue&type=script&lang=js"
export * from "./dormStaff.vue?vue&type=script&lang=js"
import style0 from "./dormStaff.vue?vue&type=style&index=0&id=1d1fd302&prod&scoped=true&lang=css"
import style1 from "./dormStaff.vue?vue&type=style&index=1&id=1d1fd302&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1fd302",
  null
  
)

export default component.exports